import type { ReactNode } from 'react'

/**
 * Título de pantalla.
 *
 * Los títulos de RH habían derivado a cinco combinaciones distintas (de
 * text-xl a text-3xl, bold y semibold mezclados, y en dos pantallas el azul
 * corporativo en vez del negro) porque cada pantalla traía los suyos escritos
 * a mano. Aquí viven los dos únicos que existen, los mismos que usa almacén:
 *
 *   listado → pantallas de nivel superior, las que cuelgan del menú.
 *             Bandeja de solicitudes, Herramientas, Empleados expedientes.
 *   interna → pantallas de detalle, a las que se llega con un botón Volver.
 *             Ver solicitud, Ver candidato, Nueva solicitud de vacante.
 *
 * El tamaño no se pasa por className: si una pantalla necesita otro, es que
 * falta un nivel y hay que agregarlo aquí, no esquivarlo desde afuera.
 */
type NivelDeTitulo = 'listado' | 'interna'

const ESTILOS: Record<NivelDeTitulo, string> = {
  listado: 'text-2xl font-bold text-gray-900',
  interna: 'text-xl font-semibold text-gray-900',
}

interface TituloDePantallaProps {
  children: ReactNode
  nivel?: NivelDeTitulo
  /** Solo para espaciado (mb-2, ml-6). El tamaño y el peso salen del nivel. */
  className?: string
}

export function TituloDePantalla({
  children,
  nivel = 'listado',
  className = '',
}: TituloDePantallaProps) {
  return <h1 className={`${ESTILOS[nivel]} ${className}`}>{children}</h1>
}
